import React from 'react';
import { getColorThemeByName, getTheme } from "../../helper";
import { connect } from "react-redux";
import { motion } from "framer-motion";

const CodingBro = (Props) => {
    const { width = "100%" } = Props

    const anim = {
        animate: { rotate: [-5, 5] },
        transition: { repeat: Infinity, duration: 2, delay: 0.5, repeatType: "reverse" }
    }

    return (
        <div style={{ width: "fit-content", margin: "auto" }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" width={width}>
                <path
                    d="M402.82 122.51a210.4 210.4 0 0 0-57.34-40.24C313.86 67.48 279 60.36 244.2 59.93c-101.79-1.23-109.54 118.35-140.84 135s-88 18.59-90 85.09c-1.23 41.83 8.54 84.85 36 117.44 25.15 29.85 62.09 45 98.49 56.15 40.88 12.56 84.23 24.87 127.23 16.4 44.13-8.69 75.13-43.63 111.36-67.24 22.82-14.87 43.3-30.52 57.39-54.38 1.68-2.84 3.26-5.76 4.76-8.71 18.86-37.06 22.56-79.82 12.16-119.93-9.32-36.03-30.39-70.3-57.93-97.24Z"
                    style={{
                        fill: Props.colorTheme.activeColor,
                    }}
                />
                <path
                    d="M402.82 122.51a210.4 210.4 0 0 0-57.34-40.24C313.86 67.48 279 60.36 244.2 59.93c-101.79-1.23-109.54 118.35-140.84 135s-88 18.59-90 85.09c-1.23 41.83 8.54 84.85 36 117.44 25.15 29.85 62.09 45 98.49 56.15 40.88 12.56 84.23 24.87 127.23 16.4 44.13-8.69 75.13-43.63 111.36-67.24 22.82-14.87 43.3-30.52 57.39-54.38 1.68-2.84 3.26-5.76 4.76-8.71 18.86-37.06 22.56-79.82 12.16-119.93-9.32-36.03-30.39-70.3-57.93-97.24Z"
                    style={{
                        fill: "#fff",
                        opacity: 0.7000000000000001,
                    }}
                />
                <path
                    d="M402.38 139.9a2.45 2.45 0 0 1 .11.65v.69a6.09 6.09 0 0 1-.19 1.57 3.48 3.48 0 0 1-.6 1.29 3.08 3.08 0 0 1-1.08.9 3.67 3.67 0 0 1-1.68.35 4.69 4.69 0 0 1-1.92-.42 23 23 0 0 1-2.33-1.2L384.8 138a8 8 0 0 1-.65-7.15 4 4 0 0 1 1.62-1.66l12.69-7.39a5.71 5.71 0 0 1 3.07 1.64 3.62 3.62 0 0 1 .8 2.24 3.65 3.65 0 0 1-.8 2.51 7.88 7.88 0 0 1-2.38 1.69L391 134ZM419.68 150.43c-.43.06-.84.09-1.24.11s-.77 0-1.11 0a4.66 4.66 0 0 1-3-.83 3.21 3.21 0 0 1-1-2.67 9.24 9.24 0 0 1 .36-2.52c.25-.84.47-1.59.65-2.24l8.12-29.3c.46-.06.89-.1 1.3-.12h1.1a4.85 4.85 0 0 1 2.93.79 2.88 2.88 0 0 1 1.09 2.53 8.76 8.76 0 0 1-.37 2.54q-.37 1.2-.69 2.4ZM439.8 127.26a2.45 2.45 0 0 1-.11-.65v-.69a6.62 6.62 0 0 1 .18-1.57 3.48 3.48 0 0 1 .6-1.29 3.12 3.12 0 0 1 1.09-.9 3.61 3.61 0 0 1 1.68-.35 4.64 4.64 0 0 1 1.91.42c.63.28 1.41.68 2.33 1.2l9.93 5.72a6.66 6.66 0 0 1 1.2 4.15 6.54 6.54 0 0 1-.56 3 4 4 0 0 1-1.61 1.67l-12.69 7.38a5.67 5.67 0 0 1-3.07-1.64 3.57 3.57 0 0 1-.81-2.24 3.62 3.62 0 0 1 .81-2.51 8.13 8.13 0 0 1 2.37-1.69l8.13-4.1ZM252.39 135.63v12.8h36.24v-29.7h29.69V82.5H301.6M237.63 82.5h-14.94v36.23h29.7v10.63M296.51 82.5h-7.88V52.8h-36.24v29.7h-7.59"
                    style={{
                        fill: "none",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <circle
                    cx={270.51}
                    cy={100.61}
                    r={7.54}
                    style={{
                        fill: "none",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="m270.9 64.45-5.82 10.09h11.65l-5.83-10.09zM270.9 139.1l5.83-10.1h-11.65l5.82 10.1zM233.58 101.77l10.09 5.83V95.95l-10.09 5.82zM308.23 101.77l-10.1-5.82v11.65l10.1-5.83zM405.15 211.84a4.88 4.88 0 0 0-6.91 0l-1.58 1.58-1.58-1.58a4.89 4.89 0 0 0-6.91 6.91l8.33 8.34.16-.16.16.16 8.33-8.34a4.88 4.88 0 0 0 0-6.91ZM428.07 211.84a4.88 4.88 0 0 0-6.91 0l-1.58 1.58-1.58-1.58a4.89 4.89 0 1 0-6.91 6.91l8.33 8.34.16-.16.16.16 8.33-8.34a4.88 4.88 0 0 0 0-6.91ZM451 211.84a4.88 4.88 0 0 0-6.91 0l-1.58 1.58-1.58-1.58a4.89 4.89 0 0 0-6.91 6.91l8.33 8.34.16-.16.16.16 8.33-8.34a4.88 4.88 0 0 0 0-6.91ZM114.51 99.07a5.67 5.67 0 0 0-7.5 0l-1.71 1.57-1.72-1.57a5.67 5.67 0 0 0-7.5 0 4.57 4.57 0 0 0 0 6.86l9 8.27.18-.16.17.16 9-8.27a4.57 4.57 0 0 0 .08-6.86ZM139.37 99.07a5.67 5.67 0 0 0-7.5 0l-1.71 1.57-1.72-1.57a5.67 5.67 0 0 0-7.5 0 4.57 4.57 0 0 0 0 6.86l9.06 8.27.17-.16.17.16 9-8.27a4.57 4.57 0 0 0 .03-6.86ZM164.23 99.07a5.66 5.66 0 0 0-7.49 0l-1.74 1.57-1.71-1.57a5.67 5.67 0 0 0-7.5 0 4.57 4.57 0 0 0 0 6.86l9 8.27.21-.2.17.16 9-8.27a4.55 4.55 0 0 0 .06-6.82Z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M380.99 263.91h20.76v7.28h-20.76z"
                />
                <path
                    style={{
                        fill: Props.colorTheme.activeColor,
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M401.93 271.19H380.8l2.64 27.86h15.85l2.64-27.86z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M378.72 269.91h25.29v4.29h-25.29z"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M247.65 181.57h123.66v96.75H247.65z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M251.64 184.69h115.68v86.88H251.64z"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M336.87 184.69h30.45v86.88h-30.45z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M251.64 184.69h115.68v4.75H251.64zM263.95 239.19h12.47v25.07h-12.47z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M263.95 252.4h12.47v11.86h-12.47zM264.2 254.5h12.1M264.2 256.85h12.1M264.2 259.19h12.1M264.2 261.54h12.1"
                />
                <path
                    d="M262.87 257h6.39v7.29h0-12.47 0v-1.2a6.08 6.08 0 0 1 6.08-6.09Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    transform="rotate(180 288.96 251.72)"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M282.72 239.19h12.47v25.07h-12.47z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M282.72 252.4h12.47v11.86h-12.47zM294.95 254.5h-12.1M294.95 256.85h-12.1M294.95 259.19h-12.1M294.95 261.54h-12.1"
                />
                <path
                    d="M289.89 257h12.47v7.29h0H296a6.08 6.08 0 0 1-6.08-6.08V257h-.03Z"
                    transform="rotate(180 296.125 260.615)"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: Props.colorTheme.activeColor,
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M264.08 235.98v5.59l12.25 8.98h6.18l11.67-8.59v-5.98h-30.1z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M264.08 213.69h30.01v22.29h-30.01z"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M264.56 228.91h29.62v7.53h-29.62z"
                />
                <path
                    d="M259.07 217.74s-3.05 4.38-3.05 8.09v21.95a1 1 0 0 0 1 1h7.83a1 1 0 0 0 1-1h0a1 1 0 0 1 1-1H268a1 1 0 0 0 1-1v-28.17s-6.88-4.12-9.93.13Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M256.02 232.59h13v8.36h-13z"
                />
                <path
                    d="M301.29 217.74s3 4.38 3 8.09v21.95a1 1 0 0 1-1 1h-7.83a1 1 0 0 1-1-1h0a1 1 0 0 0-1-1h-1.2a1 1 0 0 1-1-1v-28.17s6.97-4.12 10.03.13Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M291.34 232.59h13v8.36h-13z"
                />
                <path
                    d="M276.63 210.43a12.15 12.15 0 0 0-11.42.53c-5.87 3.52-5.44 7.58-4.48 9s3.09 1.6 5 .75 3-4.16 6.94-4.59 6-1.49 5.55-4.05-1.59-1.64-1.59-1.64ZM283.9 210.43a12.15 12.15 0 0 1 11.42.53c5.87 3.52 5.44 7.58 4.48 9s-3.09 1.6-5 .75-3-4.16-6.94-4.59-6-1.49-5.55-4.05 1.59-1.64 1.59-1.64ZM282.71 200.16h5.39l1.38-3.44a.25.25 0 0 1 .48.09v5.49a2.7 2.7 0 0 1-2.7 2.7h-4.55ZM277.76 200.16h-5.39l-1.37-3.44a.25.25 0 0 0-.48.09v5.49a2.69 2.69 0 0 0 2.69 2.7h4.56Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M276.31 205.18a7.19 7.19 0 0 0-.55 2.79c0 3.19 2 5.77 4.38 5.77s4.37-2.58 4.37-5.77a7.19 7.19 0 0 0-.55-2.79Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M276.31 205.18s.58-7.81 4.3-7.62 3.35 7.62 3.35 7.62Z"
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M276.31 208.06a7.19 7.19 0 0 0-.55 2.79c0 3.19 2 5.77 4.38 5.77s4.37-2.58 4.37-5.77a7.19 7.19 0 0 0-.55-2.79Z"
                    style={{
                        fill: Props.colorTheme.activeColor,
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M279.08 205.09H281v4.37h-1.92zM280.14 216.62v12.12M335.57 189.43h3.35v81.81h-3.35z"
                />
                <path
                    style={{
                        fill: Props.colorTheme.activeColor,
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M306.21 192.99h5.95v5.95h-5.95z"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M306.21 201.17h5.95v5.95h-5.95z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M306.21 209.22h5.95v5.95h-5.95z"
                />
                <path
                    d="M342.9 195.37h-1.53a.37.37 0 0 1-.37-.37.38.38 0 0 1 .37-.38h1.53a.37.37 0 0 1 .37.38.36.36 0 0 1-.37.37Zm.37 1.37a.37.37 0 0 0-.37-.38h-1.53a.38.38 0 0 0-.37.38.37.37 0 0 0 .37.37h1.53a.36.36 0 0 0 .37-.37Zm0 1.74a.37.37 0 0 0-.37-.38h-1.53a.38.38 0 0 0 0 .76h1.53a.37.37 0 0 0 .37-.38Zm0 1.74a.37.37 0 0 0-.37-.38h-1.53a.38.38 0 0 0 0 .76h1.53a.37.37 0 0 0 .37-.38Zm0 1.74a.36.36 0 0 0-.37-.37h-1.53a.37.37 0 0 0-.37.37.38.38 0 0 0 .37.38h1.53a.37.37 0 0 0 .37-.34Zm0 1.74a.37.37 0 0 0-.37-.37h-1.53a.38.38 0 0 0 0 .75h1.53a.37.37 0 0 0 .37-.38Zm0 1.74a.37.37 0 0 0-.37-.37h-1.53a.38.38 0 0 0 0 .75h1.53a.37.37 0 0 0 .37-.38Zm0 1.75a.37.37 0 0 0-.37-.38h-1.53a.38.38 0 0 0 0 .75h1.53a.37.37 0 0 0 .37-.37ZM349 195a.37.37 0 0 0-.37-.38h-4a.38.38 0 0 0-.38.38.37.37 0 0 0 .38.37h4a.36.36 0 0 0 .37-.37Zm0 1.74a.37.37 0 0 0-.37-.38h-4a.38.38 0 0 0-.38.38.37.37 0 0 0 .38.37h4a.36.36 0 0 0 .37-.37Zm0 1.74a.37.37 0 0 0-.37-.38h-4a.38.38 0 0 0 0 .76h4a.37.37 0 0 0 .37-.38Zm0 1.74a.37.37 0 0 0-.37-.38h-4a.38.38 0 0 0 0 .76h4a.37.37 0 0 0 .37-.38Zm0 1.74a.36.36 0 0 0-.37-.37h-4a.37.37 0 0 0-.38.37.38.38 0 0 0 .38.38h4a.37.37 0 0 0 .37-.34Zm4.79 1.74a.38.38 0 0 0-.37-.37h-4a.38.38 0 1 0 0 .75h4a.38.38 0 0 0 .34-.38Zm0 1.74a.38.38 0 0 0-.37-.37h-4a.38.38 0 1 0 0 .75h4a.38.38 0 0 0 .34-.38Zm0 1.75a.38.38 0 0 0-.37-.38h-4a.38.38 0 1 0 0 .75h4a.38.38 0 0 0 .34-.37Zm-3-12.19a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .37-.43Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0-.43.44.43.43 0 0 0 .43.43.44.44 0 0 0 .34-.43Zm1.3 0a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .37-.43Zm1.31 0a.44.44 0 1 0-.87 0 .44.44 0 0 0 .87 0Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0-.43.44.43.43 0 0 0 .43.43.44.44 0 0 0 .42-.43Zm1.3 0a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .37-.43Zm-6.53 3.48a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .37-.43Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0-.43.44.43.43 0 0 0 .43.43.44.44 0 0 0 .34-.43Zm1.3 0a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .37-.43Zm1.31 0a.44.44 0 1 0-.87 0 .44.44 0 0 0 .87 0Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0-.43.44.43.43 0 0 0 .43.43.44.44 0 0 0 .42-.43Zm1.3 0a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .37-.43Zm-2.07 5a.43.43 0 0 0-.43-.44.44.44 0 1 0 0 .87.43.43 0 0 0 .37-.42Zm1.31 0a.44.44 0 1 0-.43.43.43.43 0 0 0 .37-.42Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0 0 .87.44.44 0 0 0 .38-.42Zm1.3 0a.43.43 0 0 0-.43-.44.44.44 0 1 0 0 .87.43.43 0 0 0 .37-.42Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0 0 .87.44.44 0 0 0 .38-.42Zm1.3 0a.43.43 0 0 0-.43-.44.44.44 0 1 0 0 .87.43.43 0 0 0 .37-.42Zm-6.53 3.59a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .37-.42Zm1.31 0a.44.44 0 1 0-.87 0 .44.44 0 0 0 .87 0Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0-.43.44.43.43 0 0 0 .43.43.44.44 0 0 0 .38-.42Zm1.3 0a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .37-.42Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0-.43.44.43.43 0 0 0 .43.43.44.44 0 0 0 .38-.42Zm1.3 0a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .37-.42ZM342.9 209.64h-1.53a.38.38 0 0 1 0-.75h1.53a.38.38 0 0 1 0 .75Zm.37 1.37a.37.37 0 0 0-.37-.38h-1.53a.38.38 0 0 0 0 .75h1.53a.37.37 0 0 0 .37-.38Zm0 1.74a.37.37 0 0 0-.37-.38h-1.53a.38.38 0 0 0-.37.38.37.37 0 0 0 .37.37h1.53a.36.36 0 0 0 .37-.37Zm0 1.74a.37.37 0 0 0-.37-.38h-1.53a.38.38 0 0 0-.37.38.37.37 0 0 0 .37.37h1.53a.36.36 0 0 0 .37-.37Zm0 1.74a.37.37 0 0 0-.37-.38h-1.53a.38.38 0 0 0 0 .76h1.53a.37.37 0 0 0 .37-.38Zm0 1.74a.36.36 0 0 0-.37-.37h-1.53a.37.37 0 0 0-.37.37.38.38 0 0 0 .37.38h1.53a.37.37 0 0 0 .37-.35Zm0 1.74a.36.36 0 0 0-.37-.37h-1.53a.37.37 0 0 0-.37.37.38.38 0 0 0 .37.38h1.53a.37.37 0 0 0 .37-.38Zm0 1.74a.37.37 0 0 0-.37-.37h-1.53a.38.38 0 0 0 0 .75h1.53a.37.37 0 0 0 .37-.38Zm5.7-12.18a.37.37 0 0 0-.37-.38h-4a.38.38 0 1 0 0 .75h4a.37.37 0 0 0 .4-.37Zm0 1.74a.37.37 0 0 0-.37-.38h-4a.38.38 0 1 0 0 .75h4a.37.37 0 0 0 .4-.38Zm0 1.74a.37.37 0 0 0-.37-.38h-4a.38.38 0 0 0-.38.38.37.37 0 0 0 .38.37h4a.36.36 0 0 0 .4-.37Zm0 1.74a.37.37 0 0 0-.37-.38h-4a.38.38 0 0 0-.38.38.37.37 0 0 0 .38.37h4a.36.36 0 0 0 .4-.37Zm0 1.74a.37.37 0 0 0-.37-.38h-4a.38.38 0 0 0 0 .76h4a.37.37 0 0 0 .4-.38Zm4.79 1.74a.37.37 0 0 0-.37-.37h-4a.37.37 0 0 0-.38.37.38.38 0 0 0 .38.38h4a.38.38 0 0 0 .37-.35Zm0 1.74a.37.37 0 0 0-.37-.37h-4a.37.37 0 0 0-.38.37.38.38 0 0 0 .38.38h4a.38.38 0 0 0 .37-.38Zm0 1.74a.38.38 0 0 0-.37-.37h-4a.38.38 0 1 0 0 .75h4a.38.38 0 0 0 .37-.38Zm-3-12.18a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .4-.43Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0-.43.44.43.43 0 0 0 .43.43.44.44 0 0 0 .37-.43Zm1.3 0a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .4-.43Zm1.31 0a.44.44 0 1 0-.87 0 .44.44 0 0 0 .87 0Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0-.43.44.43.43 0 0 0 .43.43.44.44 0 0 0 .45-.43Zm1.3 0a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .4-.43Zm-6.53 3.48a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .4-.43Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0-.43.44.43.43 0 0 0 .43.43.44.44 0 0 0 .37-.43Zm1.3 0a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .4-.43Zm1.31 0a.44.44 0 1 0-.87 0 .44.44 0 0 0 .87 0Zm1.31 0a.44.44 0 0 0-.44-.44.44.44 0 0 0-.43.44.43.43 0 0 0 .43.43.44.44 0 0 0 .45-.43Zm1.3 0a.44.44 0 0 0-.43-.44.44.44 0 0 0-.44.44.44.44 0 0 0 .44.43.43.43 0 0 0 .4-.43Zm-2.07 5a.43.43 0 0 0-.43-.43.44.44 0 0 0-.44.43.44.44 0 0 0 .44.44.44.44 0 0 0 .4-.44Zm1.31 0a.44.44 0 0 0-.87 0 .44.44 0 1 0 .87 0Zm1.31 0a.44.44 0 0 0-.44-.43.43.43 0 0 0-.43.43.44.44 0 0 0 .43.44.44.44 0 0 0 .41-.44Zm1.3 0a.43.43 0 0 0-.43-.43.44.44 0 0 0-.44.43.44.44 0 0 0 .44.44.44.44 0 0 0 .4-.44Zm1.31 0a.44.44 0 0 0-.44-.43.43.43 0 0 0-.43.43.44.44 0 0 0 .43.44.44.44 0 0 0 .41-.44Zm1.3 0a.43.43 0 0 0-.43-.43.44.44 0 0 0-.44.43.44.44 0 0 0 .44.44.44.44 0 0 0 .4-.44Zm-6.53 3.59a.43.43 0 0 0-.43-.43.44.44 0 1 0 0 .87.43.43 0 0 0 .4-.44Zm1.31 0a.44.44 0 0 0-.87 0 .44.44 0 1 0 .87 0Zm1.31 0a.44.44 0 0 0-.44-.43.44.44 0 0 0 0 .87.44.44 0 0 0 .41-.44Zm1.3 0a.43.43 0 0 0-.43-.43.44.44 0 1 0 0 .87.43.43 0 0 0 .4-.44Zm1.31 0a.44.44 0 0 0-.44-.43.44.44 0 0 0 0 .87.44.44 0 0 0 .41-.44Zm1.3 0a.43.43 0 0 0-.43-.43.44.44 0 1 0 0 .87.43.43 0 0 0 .4-.44Z"
                    style={{
                        fill: Props.colorTheme.activeColor,
                    }}
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M310.96 219.77h21.62v13.71h-21.62z"
                />
                <path
                    d="M321.65 252.31h0a1.63 1.63 0 0 1-1.63-1.63v-30.91h3.26v30.91a1.63 1.63 0 0 1-1.63 1.63Z"
                    style={{
                        fill: Props.colorTheme.activeColor,
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M320.26 235.12h2.55l-2.55 3.02h3.02l-3.02 3.25h3.02l-3.02 3.02h2.79l-3.03 2.79h2.56l-2.56 2.67h3.26"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M315.37 219.77h12.78v13.71h-12.78z"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M300.02 274.59h12.56v25.69h-12.56zM365.79 280.48l10.83 18.24h-23.66l12.83-18.24z"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M376.84 263.66h-65.55l-20.4 35.63h65.56l20.39-35.63z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M367.38 267.37h-50.87l-16 27.93h50.88l15.99-27.93z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="m335.5 295.01 6.64-11.6h-22.82l-6.64 11.6h22.82z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="m335.57 295.01.02-.03h-22.53l-.02.03h22.53z"
                />
                <path
                    d="m316.43 295 4.94-8.63a5.88 5.88 0 0 0-7.62.1s-4.23 3.33-5.85 6.16l-1.36 2.37ZM343.29 295l1.36-2.37a11.12 11.12 0 0 0 1.21-6.16c-.48-3.22-7.51-.1-7.51-.1l-4.94 8.63Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M330.28 280.92s-2.91-2.27-8.91.41-7.44 5.76-7.31 6.82 1.66 1.21 3.49.56 4.08-3.16 7.27-3.49 5.2-1.13 6-3.08-.54-1.22-.54-1.22ZM335.82 280.92s5.52-2.27 8.45.41.84 5.76-.49 6.82a3.81 3.81 0 0 1-4.14.56c-1.09-.65-.46-3.16-3.28-3.49s-3.89-1.13-2.46-3.08 1.92-1.22 1.92-1.22ZM339.38 273.12h4.1l2.52-2.62c.19-.2.44-.14.32.07l-2.32 4.17a4.19 4.19 0 0 1-3.22 2.05h-3.47ZM335.62 273.12h-4.11l.46-2.62c0-.2-.29-.14-.41.07l-2.39 4.17c-.65 1.14-.26 2.05.88 2.05h3.46Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M332.33 276.94a9.89 9.89 0 0 0-1.63 2.12c-1.39 2.42-1 4.38.81 4.38s4.45-2 5.84-4.38a6.46 6.46 0 0 0 .8-2.12ZM332.33 276.94s3.84-5.95 6.59-5.8-.77 5.8-.77 5.8Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M331.07 279.13a10.5 10.5 0 0 0-1.63 2.12c-1.38 2.42-1 4.38.82 4.38s4.45-2 5.83-4.38a6.16 6.16 0 0 0 .8-2.12Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M334.03 280.19h-1.46l1.9-3.32h1.47l-1.91 3.32zM330.26 285.63q-2.31 4-4.61 8.06"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M175.52 273.93h9.61v20.25h-9.61z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M121.45 181.13h121.21v97.61H121.45z"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M127.93 186.21h108.25v84.67H127.93z"
                />
                <path
                    d="M193.07 192h-2.79a.69.69 0 0 1 0-1.38h2.79a.69.69 0 0 1 0 1.38Zm.68 2.5a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38h2.79a.68.68 0 0 0 .68-.66Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38h2.79a.68.68 0 0 0 .68-.66Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38h2.79a.68.68 0 0 0 .68-.66Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h2.79a.67.67 0 0 0 .68-.65Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h2.79a.67.67 0 0 0 .68-.65Zm0 3.18a.67.67 0 0 0-.68-.68h-2.79a.69.69 0 1 0 0 1.37h2.79a.68.68 0 0 0 .68-.66Zm0 3.19a.67.67 0 0 0-.68-.68h-2.79a.68.68 0 0 0-.69.68.69.69 0 0 0 .69.69h2.79a.68.68 0 0 0 .68-.66Zm10.44-22.32a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .69-.66Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .69-.66Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .69-.66Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .69-.66Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h7.32a.68.68 0 0 0 .69-.65Zm8.77 3.19a.69.69 0 0 0-.69-.69H205a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h7.32a.68.68 0 0 0 .68-.65Zm0 3.18a.68.68 0 0 0-.69-.68H205a.69.69 0 1 0 0 1.37h7.32a.69.69 0 0 0 .68-.66Zm0 3.19a.68.68 0 0 0-.69-.68H205a.68.68 0 0 0-.69.68.69.69 0 0 0 .69.69h7.32a.69.69 0 0 0 .68-.66Zm-5.54-22.32a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .8-.77Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .82-.77Zm2.39 0a.79.79 0 0 0-.79-.79.79.79 0 0 0-.8.79.8.8 0 0 0 .8.8.79.79 0 0 0 .79-.77Zm-12 6.38a.8.8 0 1 0-.8.8.8.8 0 0 0 .85-.77Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .85-.77Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .85-.77Zm2.39 0a.8.8 0 0 0-.8-.8.8.8 0 0 0 0 1.6.8.8 0 0 0 .85-.77Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .87-.77Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 0 0 0 1.6.79.79 0 0 0 .84-.77Zm-3.78 9.17a.8.8 0 1 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-.8-.8.79.79 0 0 0-.79.8.79.79 0 0 0 .79.79.79.79 0 0 0 .85-.76Zm2.39 0a.8.8 0 0 0-.8-.8.79.79 0 0 0-.79.8.79.79 0 0 0 .79.79.79.79 0 0 0 .85-.76Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 0 0-.8.8.79.79 0 0 0 .8.79.79.79 0 0 0 .84-.76Zm2.4 0a.8.8 0 1 0-1.6 0 .8.8 0 0 0 1.6 0Zm-12 6.57a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .89-.77Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .89-.77Zm2.39 0a.79.79 0 0 0-.79-.79.79.79 0 0 0-.8.79.8.8 0 0 0 .8.8.79.79 0 0 0 .88-.77Zm2.4 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0ZM193.07 217.55h-2.79a.69.69 0 0 1 0-1.38h2.79a.69.69 0 0 1 0 1.38Zm.68 2.5a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38h2.79a.68.68 0 0 0 .68-.69Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h2.79a.67.67 0 0 0 .68-.68Zm0 3.18a.67.67 0 0 0-.68-.68h-2.79a.69.69 0 1 0 0 1.37h2.79a.68.68 0 0 0 .68-.69Zm0 3.19a.67.67 0 0 0-.68-.68h-2.79a.68.68 0 0 0-.69.68.69.69 0 0 0 .69.69h2.79a.68.68 0 0 0 .68-.69Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38h2.79a.68.68 0 0 0 .68-.69Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 1 0 0 1.38h2.79a.68.68 0 0 0 .68-.68Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38h2.79a.68.68 0 0 0 .68-.69Zm10.44-22.32a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .69-.69Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .69-.69Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h7.32a.68.68 0 0 0 .69-.68Zm0 3.18a.68.68 0 0 0-.69-.68h-7.32a.69.69 0 1 0 0 1.37h7.32a.69.69 0 0 0 .69-.69Zm0 3.19a.68.68 0 0 0-.69-.68h-7.32a.68.68 0 0 0-.69.68.69.69 0 0 0 .69.69h7.32a.69.69 0 0 0 .69-.69Zm8.81 3.19a.69.69 0 0 0-.69-.69H205a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .68-.69Zm0 3.19a.69.69 0 0 0-.69-.69H205a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .68-.68Zm0 3.19a.69.69 0 0 0-.69-.69H205a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .68-.69Zm-5.54-22.32a.8.8 0 1 0-.8.8.8.8 0 0 0 .76-.8Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .76-.8Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .76-.8Zm2.39 0a.8.8 0 0 0-.8-.8.8.8 0 0 0 0 1.6.8.8 0 0 0 .76-.8Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .78-.8Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 1 0 0 1.6.79.79 0 0 0 .75-.8Zm-12 6.38a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-.8-.8.79.79 0 0 0-.79.8.79.79 0 0 0 .79.79.79.79 0 0 0 .81-.79Zm2.39 0a.8.8 0 1 0-1.59 0 .8.8 0 0 0 1.59 0Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 0 0-.8.8.79.79 0 0 0 .8.79.79.79 0 0 0 .8-.79Zm-3.78 9.16a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .81-.8Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .81-.8Zm2.39 0a.79.79 0 0 0-.79-.79.79.79 0 0 0-.8.79.8.8 0 0 0 .8.8.79.79 0 0 0 .8-.8Zm2.4 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm-12 6.58a.8.8 0 1 0-.8.8.8.8 0 0 0 .85-.78Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .87-.78Zm2.39 0a.8.8 0 0 0-.8-.8.8.8 0 0 0 0 1.6.8.8 0 0 0 .85-.78Zm2.39 0a.8.8 0 0 0-.8-.8.8.8 0 0 0 0 1.6.8.8 0 0 0 .85-.78Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 0 0 0 1.6.79.79 0 0 0 .84-.78Zm2.4 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .85-.78ZM193.07 243.68h-2.79a.69.69 0 1 1 0-1.38h2.79a.69.69 0 0 1 0 1.38Zm.68 2.5a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38h2.79a.68.68 0 0 0 .68-.69Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 1 0 0 1.38h2.79a.68.68 0 0 0 .68-.69Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38h2.79a.68.68 0 0 0 .68-.69Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h2.79a.67.67 0 0 0 .68-.68Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h2.79a.67.67 0 0 0 .68-.68Zm0 3.18a.67.67 0 0 0-.68-.68h-2.79a.68.68 0 0 0-.69.68.69.69 0 0 0 .69.69h2.79a.68.68 0 0 0 .68-.69Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 1 0 0 1.38h2.79a.68.68 0 0 0 .68-.69ZM204.19 243a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .69-.69Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .69-.7Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .69-.7Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .69-.7Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h7.32a.68.68 0 0 0 .69-.69Zm8.77 3.19a.69.69 0 0 0-.69-.69H205a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h7.32a.68.68 0 0 0 .68-.69Zm0 3.18a.68.68 0 0 0-.69-.68H205a.68.68 0 0 0-.69.68.69.69 0 0 0 .69.69h7.32a.69.69 0 0 0 .68-.7Zm0 3.19a.69.69 0 0 0-.69-.69H205a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .68-.7ZM207.42 243a.8.8 0 1 0-.8.8.8.8 0 0 0 .8-.8Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .8-.8Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .8-.8Zm2.39 0a.8.8 0 0 0-.8-.8.8.8 0 0 0 0 1.6.8.8 0 0 0 .8-.8Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .82-.8Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 1 0 0 1.6.79.79 0 0 0 .79-.8Zm-12 6.38a.8.8 0 1 0-.8.8.8.8 0 0 0 .85-.81Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .85-.81Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .85-.81Zm2.39 0a.8.8 0 0 0-.8-.8.8.8 0 0 0 0 1.6.8.8 0 0 0 .85-.81Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .87-.81Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 1 0 0 1.6.79.79 0 0 0 .84-.81Zm-3.78 9.17a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-.8-.8.79.79 0 0 0-.79.8.79.79 0 0 0 .79.79.79.79 0 0 0 .85-.8Zm2.39 0a.8.8 0 0 0-.8-.8.79.79 0 0 0-.79.8.79.79 0 0 0 .79.79.79.79 0 0 0 .85-.8Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 0 0-.8.8.79.79 0 0 0 .8.79.79.79 0 0 0 .84-.8Zm2.4 0a.8.8 0 1 0-1.6 0 .8.8 0 0 0 1.6 0Zm-12 6.57a.8.8 0 0 0-1.6 0 .8.8 0 1 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .89-.81Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .89-.81Zm2.39 0a.79.79 0 0 0-.79-.79.79.79 0 0 0-.8.79.8.8 0 0 0 .8.8.79.79 0 0 0 .88-.81Zm2.4 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0ZM150 192h-2.79a.69.69 0 0 1 0-1.38H150a.69.69 0 0 1 0 1.38Zm.68 2.5a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38H150a.68.68 0 0 0 .63-.66Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38H150a.68.68 0 0 0 .63-.66Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38H150a.68.68 0 0 0 .63-.66Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68H150a.67.67 0 0 0 .63-.65Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68H150a.67.67 0 0 0 .63-.65Zm0 3.18a.67.67 0 0 0-.68-.68h-2.79a.69.69 0 1 0 0 1.37H150a.68.68 0 0 0 .63-.66Zm0 3.19a.67.67 0 0 0-.68-.63h-2.79a.68.68 0 0 0-.69.68.69.69 0 0 0 .69.69H150a.68.68 0 0 0 .63-.71Zm10.44-22.32a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .64-.66Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .64-.66Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .64-.66Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .64-.66Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h7.32a.68.68 0 0 0 .64-.65Zm8.77 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h7.32a.68.68 0 0 0 .64-.65Zm0 3.18a.68.68 0 0 0-.69-.68h-7.32a.69.69 0 1 0 0 1.37h7.32a.69.69 0 0 0 .64-.66Zm0 3.19a.68.68 0 0 0-.69-.68h-7.32a.68.68 0 0 0-.69.68.69.69 0 0 0 .69.69h7.32a.69.69 0 0 0 .64-.66Zm-5.54-22.32a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .75-.77Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .75-.77Zm2.39 0a.79.79 0 0 0-.79-.79.79.79 0 0 0-.8.79.8.8 0 0 0 .8.8.79.79 0 0 0 .74-.77Zm-11.95 6.38a.8.8 0 1 0-.8.8.8.8 0 0 0 .75-.77Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .75-.77Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .75-.77Zm2.39 0a.8.8 0 0 0-.8-.8.8.8 0 0 0 0 1.6.8.8 0 0 0 .75-.77Zm2.39 0a.8.8 0 0 0-.8-.8.8.8 0 0 0 0 1.6.8.8 0 0 0 .75-.77Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 0 0 0 1.6.79.79 0 0 0 .74-.77Zm-3.78 9.17a.8.8 0 1 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 1 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-.8-.8.79.79 0 0 0-.79.8.79.79 0 0 0 .79.79.79.79 0 0 0 .75-.76Zm2.39 0a.8.8 0 0 0-.8-.8.79.79 0 0 0-.79.8.79.79 0 0 0 .79.79.79.79 0 0 0 .75-.76Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 0 0-.8.8.79.79 0 0 0 .8.79.79.79 0 0 0 .71-.76Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 0 0-.8.8.79.79 0 0 0 .8.79.79.79 0 0 0 .74-.76Zm-11.95 6.57a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .75-.77Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .75-.77Zm2.39 0a.79.79 0 0 0-.79-.79.79.79 0 0 0-.8.79.8.8 0 0 0 .8.8.79.79 0 0 0 .71-.77Zm2.39 0a.79.79 0 0 0-.79-.79.79.79 0 0 0-.8.79.8.8 0 0 0 .8.8.79.79 0 0 0 .74-.77ZM150 218.16h-2.79a.69.69 0 1 1 0-1.37H150a.69.69 0 0 1 0 1.37Zm.68 2.5a.67.67 0 0 0-.68-.66h-2.79a.68.68 0 0 0-.69.68.69.69 0 0 0 .69.69H150a.68.68 0 0 0 .63-.71Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38H150a.68.68 0 0 0 .63-.69Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38H150a.68.68 0 0 0 .63-.73Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38H150a.68.68 0 0 0 .63-.69Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38H150a.68.68 0 0 0 .63-.69Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0 0 1.38H150a.68.68 0 0 0 .63-.69Zm0 3.19a.68.68 0 0 0-.68-.69h-2.79a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68H150a.67.67 0 0 0 .63-.68Zm10.44-22.32a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 1 0 0 1.37h7.32a.68.68 0 0 0 .64-.68Zm0 3.18a.68.68 0 0 0-.69-.68h-7.32a.68.68 0 0 0-.69.68.69.69 0 0 0 .69.69h7.32a.69.69 0 0 0 .64-.69Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .64-.69Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .64-.73Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0 0 1.38h7.32a.69.69 0 0 0 .64-.69Zm8.77 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 1 0 0 1.38h7.32a.69.69 0 0 0 .64-.69Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 1 0 0 1.38h7.32a.69.69 0 0 0 .64-.69Zm0 3.19a.69.69 0 0 0-.69-.69h-7.32a.69.69 0 0 0-.69.69.68.68 0 0 0 .69.68h7.32a.68.68 0 0 0 .64-.68Zm-5.54-22.33a.8.8 0 1 0-.8.8.79.79 0 0 0 .75-.8Zm2.39 0a.8.8 0 1 0-.8.8.79.79 0 0 0 .75-.8Zm2.39 0a.8.8 0 1 0-.8.8.79.79 0 0 0 .75-.8Zm2.39 0a.79.79 0 0 0-.8-.79.8.8 0 0 0 0 1.59.8.8 0 0 0 .75-.8Zm2.39 0a.79.79 0 0 0-.8-.79.8.8 0 0 0 0 1.59.8.8 0 0 0 .75-.8Zm2.39 0a.79.79 0 0 0-.79-.79.8.8 0 1 0 .79.79Zm-11.95 6.38a.8.8 0 0 0-1.6 0 .8.8 0 1 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 1 0 1.6 0Zm2.39 0a.8.8 0 0 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .75-.8Zm2.39 0a.79.79 0 0 0-.8-.79.79.79 0 0 0-.79.79.79.79 0 0 0 .79.8.8.8 0 0 0 .75-.8Zm2.39 0a.79.79 0 0 0-.79-.79.79.79 0 0 0-.8.79.8.8 0 0 0 .8.8.79.79 0 0 0 .74-.8Zm-3.83 9.15a.8.8 0 1 0-.8.8.8.8 0 0 0 .8-.8Zm2.39 0a.8.8 0 1 0-.8.8.8.8 0 0 0 .8-.8Zm2.39 0a.8.8 0 0 0-.8-.8.8.8 0 0 0 0 1.6.8.8 0 0 0 .8-.8Zm2.39 0a.8.8 0 0 0-.8-.8.8.8 0 0 0 0 1.6.8.8 0 0 0 .8-.8Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 1 0 0 1.6.79.79 0 0 0 .76-.8Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 0 0 0 1.6.79.79 0 0 0 .79-.8Zm-11.95 6.58a.8.8 0 1 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 1 0-1.6 0 .8.8 0 0 0 1.6 0Zm2.39 0a.8.8 0 0 0-.8-.8.79.79 0 0 0-.79.8.79.79 0 0 0 .79.79.79.79 0 0 0 .8-.77Zm2.39 0a.8.8 0 0 0-.8-.8.79.79 0 0 0-.79.8.79.79 0 0 0 .79.79.79.79 0 0 0 .8-.77Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 0 0-.8.8.79.79 0 0 0 .8.79.79.79 0 0 0 .76-.77Zm2.39 0a.79.79 0 0 0-.79-.8.8.8 0 0 0-.8.8.79.79 0 0 0 .8.79.79.79 0 0 0 .79-.77Z"
                    style={{
                        fill: Props.colorTheme.activeColor,
                    }}
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M215.5 295.42h4.29v1.43h-4.29zM221.53 295.42h4.29v1.43h-4.29zM227.56 295.42h4.29v1.43h-4.29zM233.6 295.42h4.29v1.43h-4.29zM239.63 295.42h4.29v1.43h-4.29zM245.66 295.42h4.29v1.43h-4.29zM251.7 295.42h4.29v1.43h-4.29zM257.73 295.42h4.29v1.43h-4.29zM263.76 295.42h4.29v1.43h-4.29zM269.8 295.42h4.29v1.43h-4.29zM275.83 295.42h4.29v1.43h-4.29zM281.86 295.42h4.29v1.43h-4.29zM287.9 295.42h4.29v1.43h-4.29z"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M293.93 295.42h4.29v1.43h-4.29zM299.96 295.42h4.29v1.43h-4.29z"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M212.48 296.63h93.14v2.6h-93.14z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M274.4 296.63h31.22v2.6H274.4zM134.23 455.49h0a2.46 2.46 0 0 0 2.46-2.42l2.48-149.74h-9.88l2.48 149.74a2.46 2.46 0 0 0 2.46 2.42Z"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M129.46 313.56H139l.17-10.23h-9.88l.17 10.23z"
                />
                <path
                    d="M213.13 455.49h0a2.46 2.46 0 0 0 2.46-2.42l2.48-149.74h-9.88l2.48 149.74a2.46 2.46 0 0 0 2.46 2.42Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M208.36 313.56h9.54l.17-10.23h-9.88l.17 10.23z"
                />
                <path
                    d="M287.72 455.49h0a2.47 2.47 0 0 0 2.46-2.42l2.48-149.74h-9.88l2.48 149.74a2.46 2.46 0 0 0 2.46 2.42Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M282.94 313.56h9.55l.17-10.23h-9.88l.16 10.23z"
                />
                <path
                    d="M409.46 455.49h0a2.46 2.46 0 0 0 2.46-2.42l2.48-149.74h-9.88L407 453.07a2.47 2.47 0 0 0 2.46 2.42Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M404.69 313.56h9.55l.16-10.23h-9.88l.17 10.23z"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M124.35 298.88h299.86v7.41H124.35z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M301.55 298.88h122.66v7.41H301.55zM215.5 295.42h4.29v1.43h-4.29zM221.53 295.42h4.29v1.43h-4.29zM227.56 295.42h4.29v1.43h-4.29zM233.6 295.42h4.29v1.43h-4.29zM239.63 295.42h4.29v1.43h-4.29zM245.66 295.42h4.29v1.43h-4.29zM251.7 295.42h4.29v1.43h-4.29zM257.73 295.42h4.29v1.43h-4.29zM263.76 295.42h4.29v1.43h-4.29zM269.8 295.42h4.29v1.43h-4.29zM275.83 295.42h4.29v1.43h-4.29zM281.86 295.42h4.29v1.43h-4.29zM287.9 295.42h4.29v1.43h-4.29z"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M293.93 295.42h4.29v1.43h-4.29zM299.96 295.42h4.29v1.43h-4.29z"
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M212.48 296.63h93.14v2.6h-93.14z"
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M274.4 296.63h31.22v2.6H274.4z"
                />
                <motion.g
                    {...anim}
                >
                    <ellipse
                        cx={422.62}
                        cy={320.95}
                        rx={8.88}
                        ry={23.29}
                        style={{
                            fill: Props.colorTheme.activeColor,
                            stroke: "#263238",
                            strokeMiterlimit: 10,
                        }}
                    />
                    <path
                        d="M395 306.59c2.77 8.74 8.1 14.84 11.91 13.63s4.63-9.27 1.86-18-8.11-14.84-11.91-13.63-4.61 9.26-1.86 18ZM460.18 359.27c9-1.53 15.83-6 15.16-9.89s-8.53-5.89-17.57-4.35-15.83 6-15.16 9.89 8.53 5.88 17.57 4.35ZM386.67 337.74c7.55 7.49 16.47 10.73 19.92 7.25s.13-12.37-7.42-19.86-16.47-10.73-19.92-7.25-.13 12.37 7.42 19.86ZM438.68 317.2c-7.29 10.59-9.47 21.76-4.85 24.94s14.27-2.82 21.57-13.41 9.48-21.76 4.86-24.94-14.26 2.82-21.58 13.41Z"
                        style={{
                            fill: Props.colorTheme.activeColor,
                            stroke: "#263238",
                            strokeMiterlimit: 10,
                        }}
                    />
                    <path
                        d="M442.45 393.33c8.31 3.88 16.41 4.09 18.1.47s-3.68-9.69-12-13.56-16.4-4.1-18.09-.48 3.69 9.69 11.99 13.57Z"
                        style={{
                            fill: Props.colorTheme.activeColor,
                            stroke: "#263238",
                            strokeMiterlimit: 10,
                        }}
                    />
                    <path
                        d="M382.83 359.27c-9-1.53-15.82-6-15.16-9.89s8.54-5.89 17.58-4.35 15.82 6 15.16 9.89-8.54 5.88-17.58 4.35Z"
                        style={{
                            fill: Props.colorTheme.activeColor,
                            stroke: "#263238",
                            strokeMiterlimit: 10,
                        }}
                    />
                    <path
                        d="M391.91 385.72c-8 4.58-16 5.48-18 2s2.83-10 10.77-14.55 16-5.49 18-2-2.83 9.97-10.77 14.55Z"
                        style={{
                            fill: Props.colorTheme.activeColor,
                            stroke: "#263238",
                            strokeMiterlimit: 10,
                        }}
                    />

                    <path
                        d="M411.37 375s11.63-2.26 11.63 5.61-8.24 14.23-11.61 23.21-9.74 9.37-13.11.38 1.48-25.47 13.09-29.2Z"
                        style={{
                            fill: Props.colorTheme.activeColor,
                            stroke: "#263238",
                            strokeMiterlimit: 10,
                        }}
                    />
                    <path
                        d="M419.23 375.36s-10.11 4.12-13.11 17.23"
                        style={{
                            fill: Props.colorTheme.activeColor,
                            stroke: "#263238",
                            strokeMiterlimit: 10,
                        }}
                    />
                </motion.g>

                <g>
                    <path
                        style={{
                            fill: "none",
                            stroke: "#263238",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                        }}
                        d="m421.99 343.08-.68 70.85M422.82 312.29l-.83 30.79M422.76 307.27l.06 2.36M433.86 340.63a89.43 89.43 0 0 0-8.77 33.6v43.82M449.11 317.29a105.5 105.5 0 0 0-15.25 23.34M453.91 312.22s-.92.84-2.43 2.45M406 343.92a105.11 105.11 0 0 1 14.39 28.56M395.82 332.18A83.9 83.9 0 0 1 406 343.92M384.91 323.86a46.8 46.8 0 0 1 7.78 5.52"
                    />
                    <path
                        d="M406.41 318.06c4.92 15.48 11.52 38.35 14.6 58.21M403.41 308.87c.88 2.61 1.9 5.71 3 9.19M400.34 300s.86 2.37 2.25 6.43M443.06 352.77c-6.14 2.34-14.55 8.84-17.46 17.35M454.42 350.47a38.79 38.79 0 0 0-11.36 2.3M461.77 350.65s-1.09-.16-2.89-.23"
                        style={{
                            fill: "none",
                            stroke: "#263238",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                        }}
                    />
                    <path
                        d="M399.76 352.7a28.43 28.43 0 0 1 3.22 1.42 22.51 22.51 0 0 1 12 20.08v38.61M387.65 350.42a39.76 39.76 0 0 1 12.11 2.28M381.24 350.65s.72-.1 2-.18"
                        style={{
                            fill: "none",
                            stroke: "#263238",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                        }}
                    />
                    <path
                        d="M390 375.83a39.63 39.63 0 0 1 10.79-6s9.85-1.62 12.1 4.75M385.19 380.09s.49-.54 1.39-1.39"
                        style={{
                            fill: "none",
                            stroke: "#263238",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                        }}
                    />
                    <path
                        style={{
                            fill: "none",
                            stroke: "#263238",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                        }}
                        d="M418.48 392.59v21.34"
                    />
                    <path
                        d="M442.71 382.81a38.85 38.85 0 0 0-10.65-4.56 5.32 5.32 0 0 0-5.71.11c-1.13.75-.75 6.37-.75 6.37v29.2M448.66 387.14s-.81-.75-2.25-1.84"
                        style={{
                            fill: "none",
                            stroke: "#263238",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                        }}
                    />
                </g>

                <path
                    d="M399.88 455.5a91.24 91.24 0 0 1-4.19-27.32 81.59 81.59 0 0 1 1.68-16.71h47.29a82.3 82.3 0 0 1 1.68 16.71 90.92 90.92 0 0 1-4.2 27.32Z"
                    style={{
                        fill: Props.theme.lightBackColor,
                    }}
                />
                <path
                    d="M445.88 419.28c.13 1.29.24 2.59.31 3.91h-50.35c.07-1.32.18-2.62.31-3.91ZM396.37 439.24c-.16-1.29-.29-2.59-.4-3.9h50.09c-.11 1.31-.25 2.61-.4 3.9Z"
                    style={{
                        fill: "#7a7a7a",
                    }}
                />
                <path
                    d="M440.23 428.4a2 2 0 1 0 2-2 2 2 0 0 0-2 2ZM430 428.4a2 2 0 1 0 2-2 2 2 0 0 0-2 2ZM419.85 428.4a2 2 0 1 0 2-2 2 2 0 0 0-2 2ZM409.66 428.4a2 2 0 1 0 2-2 2 2 0 0 0-2 2ZM399.47 428.4a2 2 0 1 0 2-2 2 2 0 0 0-2 2Z"
                    style={{
                        fill: "#8c8c8c",
                    }}
                />
                <path
                    d="M137.5 220.54s8.28-5.27 6-11.79-14.8-13.29-15.55-27.09 19.32-21.32 30.35-21.32 13.05.75 13.55 3.51a10.49 10.49 0 0 1 .25 3.76 46.51 46.51 0 0 1 5 5.52c2.76 3.51 5.51 8.28 4.76 10.29a9.68 9.68 0 0 0-.25 6.52c.75 2.26 9.53 3.76 8 6.27a9.18 9.18 0 0 1-4.27 3.51 73.71 73.71 0 0 1-3 14.8c-2.25 6.52-2.25 9.28-7 9.28s-6.52-3-6.52-3l-10.79 10.79Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M175.38 223.8c4.77 0 4.77-2.76 7-9.28a72.34 72.34 0 0 0 3-14.25 13 13 0 0 0-4.46.69c-4.5 1.24-8.89 6-12.26 9.38s-3.61.48-4.81-7.46a69.31 69.31 0 0 1-.24-16.11s5.29-4.57 6.73-10.1-7.93-4.33-11.06-6 12.86-3 12.86-3a10.49 10.49 0 0 0-.25-3.76c-.5-2.76-2.51-3.51-13.55-3.51s-31.1 7.52-30.35 21.32 13.3 20.57 15.55 27.09a6.88 6.88 0 0 1 .37 1.79c3.21 1.07 6.62 1.21 8.15-1.4 2.41-4.09-1.68-9.14-1-15.16s7.7-1 7.7-.24 0 10.11.24 15.16 9.84 11.89 9.84 11.89 1.77 2.95 6.54 2.95Z"
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M179.46 188.81c0 1.53-.38 2.77-.84 2.77s-.84-1.24-.84-2.77.38-2.76.84-2.76.84 1.24.84 2.76Z"
                    style={{
                        fill: "#263238",
                    }}
                />
                <path
                    d="M182.11 209.14s-4.33.72-5.53-4.33"
                    style={{
                        fill: "none",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M180.9 184.36s-3.12-3.36-6.73 1.45"
                    style={{
                        fill: "none",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                    }}
                />
                <path
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                    }}
                    d="m183.31 182.44 1.92 12.03M183.79 187.01l-26.7 5.53"
                />
                <path
                    d="M160 195s-5.53-9.62-9.14-5.53-1.68 12.5.48 15.39 7.46 1.2 8.42 0M227.08 285.62s10.58-3.62 14.19-2.62 8.42 4.57 8.42 4.57 2.16.48-2.89 1.68-12 .25-16.11-.48-6.25-.99-3.61-3.15ZM153.29 294l10.76 2.57s.25 4.87 4.87 5.63 7.47-4.55 8.86-4.58 11.63.74 11.63.74l-11-15.63-21-5.64ZM263.15 286.16l5.53.43a5 5 0 0 1 3.84 3.09l1.19 3s.22 2.91-.67 3.13-.69.21-1.35-2.24a13 13 0 0 0-1.11-3.13l-3.58-.67 1.79 1.79.89 4.47a1.84 1.84 0 0 1-2.23-.44 16.11 16.11 0 0 1-2.24-3.36l-6-5.59Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="m199 281.45 46.55 5.45s7.8-.19 15.37-1.11c3.67-.44 8 3.72 8 3.72s4.82.37 5.58 1.8 3.23 5 1.08 5.27-2.71-2.59-3.92-3-4.82-.38-7.7.17-7.64 2.34-12 2.19a13.34 13.34 0 0 1-7.28-2.48s-42.43 6.48-47.48 6.59a33.39 33.39 0 0 1-9.41-1.23Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M190 274.31s1-1.2 2.41.72 2.4 3.37 3.61 4.09 4.57-.24 2.88 4.57-7 15.15-12 17.56-8.18-1.2-9.14-3.61-5.77-1.2-5.53-7S190 274.31 190 274.31ZM188.36 435.73a51.33 51.33 0 0 0 7-.47c2.63-.46 14.12-3.71 14.49-1.62s.38 2.55-4.14 8.12-10.73 6-14.12 7.2-5.3 2.04-10.59 3.71-6.4-9.28-6.4-12.77 13.76-4.17 13.76-4.17Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M154.69 357.77s11.51 66.75 14.64 74.69 5 11.79 5 11.79 1.68 1.2 7-1.21 11.31-7.69 11.31-7.69-1-3.37-2.65-4.57-5.29-.72-5.29-3.37 2.2-73.73 2.2-73.73Z"
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M149.13 435.59s6.25 6.73 7.45 7.93 17.56 8.66 16.6 10.59-21.41 1.68-25.5.48c-2.07-.61-12.26-5.29-16.83-7.46s6.73-12.74 6.73-12.74Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M94.08 322.17v.71c-.27 4.32-1.49 27.19 2.21 31.76 4.09 5.05 18.76 6.25 32.22 6.25s50-3.36 50-3.36l-40.92 76.86 13.95 3.36s41.64-54.25 47.17-62.18 10.1-15.88 14-20.45 8.66-15.39 7.22-18.76-16.6-5.05-34.4-8.17-40.88-3.37-40.88-3.37-3.85 2.4-21.17 2.4-29.4-5.05-29.4-5.05Z"
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M178.5 357.53s20.2-2.17 26.7-6.26M209.28 354.16a157.24 157.24 0 0 1-28.13 24.29"
                    style={{
                        fill: "none",
                        stroke: "#7a7a7a",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M132.56 330.35s-10.1 9.38-18 14.43M135.93 329.39s-5.53 9.14-9.62 14.91"
                    style={{
                        fill: "none",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M132.8 221.16s-14.91 9.62-23.08 22.61-9.87 28.14-10.59 30.06-4.33 34.39-4.33 34.39-5.47 8.57-2.4 13.47c2.4 3.85.72 3.85 7 5.29 2.35.54 21.89 3.85 33.67 2.41s15.64-6.49 16.84-9.86.48-10.34 1.2-14.43 10.34-19.48 10.34-19.48 11.31 8.17 13.23 8.9 7-3.13 12.51-10.59 4.09-7.45 1.44-11.06-10.82-18.52-12.75-23.09-7.45-7.69-7.45-7.69-21.92-21.41-35.63-20.93Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M130.16 222.6s5.29-.48 13 3.13 25.25 16.36 25.25 16.36L167 231s-21.89-13.47-24.78-14.67-4.81 0-7.93 2.89a25.08 25.08 0 0 1-4.13 3.38Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="m161.42 285.62-15.63-13.47M154.21 280.09s-11.79 3.12-18.28 3.12M155.65 280.09s-7.93 8.41-16.11 13"
                />
                <path
                    d="M109.76 324.51s2.41-9.45-.74-10.93-23.9.37-35.94 4.08-16.67 11.67-15.37 11.67 43.35-7.6 52.05-4.82Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M110.36 315.48c-7.7 0-21.72 1.79-30.79 4.58a30.49 30.49 0 0 0-13.41 8c13.06-2 37.24-5.55 43.6-3.52 0-.03 1.48-5.84.6-9.06Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M63.63 326.73s-13.52 2.41-14.45 9.08 8.53 7.78 13.53 2 24.64-10.93 32.6-11.12 8.71 1.49 8.15 6.67-15.37 26.68-17 32.05 7.41 10 10.19 5.93 11.67-30.38 12-39.27-1.85-9.82-8.71-10.56-27.41 1.89-36.31 5.22Z"
                    style={{
                        fill: "#a1a1a1",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M65.86 326.73s-13.53 2.41-14.45 9.08 8.52 7.78 13.52 2 24.64-10.93 32.61-11.12 8.7 1.49 8.15 6.67-15.38 26.68-17 32.05 7.41 10 10.19 5.93 11.67-30.38 12-39.27-1.85-9.82-8.7-10.56-27.43 1.89-36.32 5.22Z"
                    style={{
                        fill: "#525252",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M118.9 412.88s-37.42 8.89-49.65 17S57 445.48 57 445.48s0 2.6 5.18 0 7.41-9.26 14.08-11.85 41.48-8.91 41.48-8.91Z"
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M70 449.11a5.92 5.92 0 1 0-5.95 5.89 5.92 5.92 0 0 0 5.95-5.89Z"
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <circle
                    cx={64.05}
                    cy={449.11}
                    r={2.48}
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M126.67 412.88s37.42 8.89 49.65 17 12.23 15.56 12.23 15.56 0 2.6-5.19 0-7.41-9.26-14.08-11.85-41.48-8.91-41.48-8.91Z"
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M175.61 449.11a5.92 5.92 0 1 1 5.92 5.91 5.92 5.92 0 0 1-5.92-5.91Z"
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M179.05 449.11a2.48 2.48 0 1 1 2.48 2.48 2.48 2.48 0 0 1-2.48-2.48Z"
                    style={{
                        fill: "#fff",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M117.77 384.08h11.36v40.64h-11.36zM97.62 375.39h54.79V384H97.62z"
                />
                <path
                    d="M180.78 351.74c-4.94-9.38-14.82-14.32-25.2-9.38s-25.69 12.84-25.69 12.84 0-26.68-4.44-39.52-9.39-15.31-5.45-25.68 9.92-9.76 8.4-25.69C127.39 253.61 118 248 118 248s-15.32-10.37-21.25-27.17-2.47-20.75-20.25-23.71S53.82 208 52.33 224.29 35.54 256.89 39 271.22s8.39 19.27 10.86 26.68 13.34 69.16 15.32 73.6 11.36 5.44 12.84 5.44h99.79s7.91-15.81 2.97-25.2ZM62.14 247a4.37 4.37 0 0 1-2.79-7.73l6.75-5.61 4.7-.49L72.09 247Zm26.35 0h-10l-2-13.83 4.83.49 8.07 5.61a5.85 5.85 0 0 1 2.38 3.36 3.35 3.35 0 0 1-3.28 4.37Z"
                    style={{
                        fill: Props.colorTheme.activeColor,
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M114.36 376.94c1-17.18-2.69-50.56-9.67-82.09-7.34-33.19-3.39-57.4-2.28-63-.27-.4-.54-.81-.8-1.23H51.13c-1.58 5.7-4.34 11.36-6.88 16.91 0 2.34.07 4.89.25 7.64 1 15.47 4.71 40.69 4.71 40.69s0 .18.1.51c.19.5.38 1 .55 1.53 2.47 7.41 13.34 69.16 15.32 73.6s11.36 5.44 12.84 5.44ZM62.14 247a4.37 4.37 0 0 1-2.79-7.73l6.75-5.61 4.7-.49L72.09 247Zm19.24-13.34 8.07 5.61a5.85 5.85 0 0 1 2.38 3.36 3.35 3.35 0 0 1-3.34 4.37h-10l-2-13.83Z"
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "#525252",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M64.68 344.62h34.64v3.7H64.68z"
                />
                <path
                    style={{
                        fill: "#525252",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="m77.02 348.27 6.42 28.22h4.48l-6.42-28.22h-4.48z"
                />
                <circle
                    cx={91.94}
                    cy={380.71}
                    r={9.16}
                    style={{
                        fill: "#525252",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <circle
                    cx={95.6}
                    cy={380.71}
                    r={6.23}
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M126.03 412.09h-5.92v21.37l1.72 4.39v9.54h2.48v-9.54l1.72-4.39v-21.37z"
                />
                <path
                    d="M123.07 455.21h0a1.91 1.91 0 0 1-1.91-1.91v-8.2a1.92 1.92 0 0 1 1.91-1.91h0a1.92 1.92 0 0 1 1.93 1.91v8.2a1.91 1.91 0 0 1-1.93 1.91Z"
                    style={{
                        fill: "#263238",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M177.44 324.51s2.41-7.22-.74-8.71-23.9-1.85-35.94 1.86-16.67 11.67-15.37 11.67 43.35-7.6 52.05-4.82Z"
                    style={{
                        fill: "#a1a1a1",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M144.45 318.62c-8.72 2.68-13.56 7.6-15.06 10.11 10.94-1.74 40.86-6.51 48.05-4.22 0 0 2.15-6.46-.28-8.41-7.06-.82-22.82-.53-32.71 2.52Z"
                    style={{
                        fill: "#525252",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M131.31 326.73s-13.52 2.41-14.45 9.08 8.53 7.78 13.53 2S155 326.92 163 326.73s8.71 1.49 8.15 6.67-15.37 26.68-17 32.05 7.41 10 10.19 5.93 11.67-30.38 12-39.27-1.85-9.82-8.71-10.56-27.42 1.85-36.32 5.18Z"
                    style={{
                        fill: "#a1a1a1",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    d="M133.54 326.73s-13.53 2.41-14.45 9.08 8.52 7.78 13.52 2 24.64-10.93 32.61-11.12 8.7 1.49 8.15 6.67-15.37 26.72-17.05 32.09 7.41 10 10.19 5.93 11.67-30.38 12-39.27-1.85-9.82-8.7-10.56-27.38 1.85-36.27 5.18Z"
                    style={{
                        fill: "#525252",
                        stroke: "#263238",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: Props.theme.normalTextColor,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                    }}
                    d="M340.2 455.5h142.28M9.5 455.5h325.81"
                />
            </svg>
        </div>
    );
}

const mapStateToProps = (state) => {

    return {
        isDarkTheme: state.theme.isDarkTheme,
        theme: getTheme(state.theme.isDarkTheme),
        nameColorTheme: state.theme.nameColorTheme,
        colorTheme: getColorThemeByName(state.theme.nameColorTheme)
    }
}

export default connect(mapStateToProps)(CodingBro);
